import { formatBytes } from '@/utils/fileSize'

/**
 * Size handling for the three cloud-storage tabs, kept out of the modals so CreateAssetModal and
 * UploadVersionModal cannot drift apart — they carry near-identical copies of this logic and only
 * one of them getting a fix is a realistic failure (ORB-721).
 */

/**
 * True only when we positively know the file is too big.
 *
 * A size we could not determine (the OneDrive picker returns items without a drive id, and no Graph
 * lookup is possible for those) must never block a submit: the server enforces the real ceiling as
 * the bytes arrive, so a guess here can only be wrong in the direction that stops legitimate work.
 */
export function isCloudFileOverLimit(
  sizeBytes: number | null | undefined,
  maxBytes: number | null | undefined,
): boolean {
  if (typeof sizeBytes !== 'number' || !Number.isFinite(sizeBytes)) return false
  if (typeof maxBytes !== 'number' || !Number.isFinite(maxBytes) || maxBytes <= 0) return false
  return sizeBytes > maxBytes
}

/**
 * The size to show beside a picked file, or null when the provider did not tell us.
 * Null means "say nothing" — rendering an unknown size as "0 B" reads as an empty file.
 */
export function cloudFileSizeLabel(sizeBytes: number | null | undefined): string | null {
  if (typeof sizeBytes !== 'number' || !Number.isFinite(sizeBytes) || sizeBytes < 0) return null
  return formatBytes(sizeBytes)
}

/** The maximum to state next to the picked file, or null when the API has not told us yet. */
export function cloudMaxSizeLabel(maxBytes: number | null | undefined): string | null {
  if (typeof maxBytes !== 'number' || !Number.isFinite(maxBytes) || maxBytes <= 0) return null
  return formatBytes(maxBytes)
}
